module.exports = __webpack_public_path__ + "media/images/edion/inside_2-241800f2427e22056a6cdf4c65e49f4b.png";